// subscription js

(function () {
  function init() {
    var ONETIME_VARIANT_ID = '49393590796525';
    var MONTHLY_VARIANT_ID = '49393590796525';
    var MONTHLY_SELLING_PLAN_ID = '10879795437';

    function applyQtySelection(card, btn) {
      card.querySelectorAll('.js-qty-btn').forEach(function (b) {
        b.classList.toggle('is-selected', b === btn);
      });

      var qty = parseInt(btn.dataset.qty, 10) || 1;
      var price = parseFloat(btn.dataset.price);
      var per = btn.dataset.per;

      var amtEl = card.querySelector('.amt');
      var perEl = card.querySelector('.per');
      var priceEl = card.querySelector('.subscription_price');
      var buyBtn = card.querySelector('.js-plan-submit_onetime');

      if (amtEl && !isNaN(price)) amtEl.textContent = '$' + price;
      if (perEl && per) perEl.textContent = per;
      if (priceEl && !isNaN(price)) priceEl.textContent = '$' + price.toFixed(2);
      if (buyBtn) {
        buyBtn.dataset.quantity = qty;
        buyBtn.disabled = false;
        if (!isNaN(price)) buyBtn.textContent = 'Buy Now — $' + price;
      }
    }

    function clearQtySelection(card) {
      card.querySelectorAll('.js-qty-btn').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      var buyBtn = card.querySelector('.js-plan-submit_onetime');
      if (buyBtn) buyBtn.disabled = true;
    }

   
    window.selectCard = function (plan, opts) {
      opts = opts || {};

      document.querySelectorAll('.js-close-buy .pr').forEach(function (card) {
        var isMatch = card.dataset.plan === plan;
        card.classList.toggle('is-selected', isMatch);
        var btn = card.querySelector('.js-plan-submit');
        if (btn) {
          if (card.dataset.plan === 'onetime') {
            var qtySelected = card.querySelector('.js-qty-btn.is-selected');
            btn.disabled = !isMatch || !qtySelected;
          } else {
            btn.disabled = !isMatch;
          }
        }
        var radio = card.querySelector('.js-plan-radio');
        if (radio) radio.checked = isMatch;
      });

      var onetimeCard = document.querySelector('.js-close-buy .pr[data-plan="onetime"]');

      if (plan === 'onetime') {
        
        if (onetimeCard && !opts.skipQtyDefault) {
          var defaultQtyBtn = onetimeCard.querySelector('.js-qty-btn[data-qty="1"]');
          if (defaultQtyBtn) applyQtySelection(onetimeCard, defaultQtyBtn);
        }
      } else {
       
        if (onetimeCard) clearQtySelection(onetimeCard);
      }
    };

    var checked = document.querySelector('.js-plan-radio:checked');
    
    window.selectCard(checked ? checked.closest('.pr').dataset.plan : 'onetime', { skipQtyDefault: true });

    function addToCartAndCheckout(variantId, quantity, sellingPlanId, btn) {
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Adding...';

      var body = { items: [{ id: variantId, quantity: quantity || 1 }] };
      if (sellingPlanId) {
        body.items[0].selling_plan = sellingPlanId;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error('Add to cart failed:', err);
          btn.disabled = false;
          btn.textContent = originalText;
          alert('Something went wrong adding this to your cart. Please try again.');
        });
    }

    function selectQty(btn) {
      var card = btn.closest('.pr');
      if (!card) return;
      applyQtySelection(card, btn);
      
      window.selectCard('onetime', { skipQtyDefault: true });
    }

    document.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.js-qty-btn');
      if (qtyBtn) {
        selectQty(qtyBtn);
        return;
      }

      var submitBtnone = e.target.closest('.js-plan-submit_onetime');
      var submitBtnmonth = e.target.closest('.js-plan-submit_monthly');

      if (submitBtnone) {
        if (submitBtnone.disabled) return;
        var qty = parseInt(submitBtnone.dataset.quantity, 10) || 1;
        addToCartAndCheckout(ONETIME_VARIANT_ID, qty, null, submitBtnone);
        return;
      }

      if (submitBtnmonth) {
        if (submitBtnmonth.disabled) return;
        addToCartAndCheckout(MONTHLY_VARIANT_ID, 1, MONTHLY_SELLING_PLAN_ID, submitBtnmonth);
        return;
      }

      var card = e.target.closest('.js-close-buy .pr');
      if (card) {
        
        window.selectCard(card.dataset.plan);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// end subscription code



  // scrolling function
  function handleScroll() {
  var height = window.innerHeight;
  var scroll = window.scrollY;
  var stickyCart = document.querySelector('#StickyAddBuy');
  var footer = document.querySelector('.new-footer-section');
  if (!stickyCart) return;

  var pastHero = scroll > height;

  var nearFooter = false;
  if (footer) {
    var footerTop = footer.getBoundingClientRect().top;
    nearFooter = footerTop <= window.innerHeight;
  }

  if (pastHero && !nearFooter) {
    stickyCart.classList.add('is-visible');
  } else {
    stickyCart.classList.remove('is-visible');
  }
}

window.addEventListener('scroll', handleScroll);
handleScroll(); 

// auto scroll on subscription 
document.addEventListener('click', function (e) {
  var btn = e.target.closest('#StickyAddBuyBtn');
  if (!btn) return;

  var subscriptionCard = document.querySelector('#buy .monthly_time_purchase');
  if (!subscriptionCard) return;

  subscriptionCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
});

// Sideslick Js
 var io=new IntersectionObserver(function(es){
  es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
},{threshold:.18});

var tio=new IntersectionObserver(function(es){es.forEach(function(e){
  if(e.isIntersecting){e.target.classList.add('in');tio.unobserve(e.target);}});},{threshold:.25});
var trk=document.querySelector('.track'); if(trk) tio.observe(trk);
document.querySelectorAll('.wk').forEach(function(el,i){
  el.style.transitionDelay=(Math.min(i,6)*45)+'ms'; io.observe(el);
});

var bb=document.getElementById('bb');
var sentinel=document.querySelector('.hero');
new IntersectionObserver(function(es){
  bb.classList.toggle('show',!es[0].isIntersecting);
},{threshold:0}).observe(sentinel);  
  